import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Equipment } from '../../../models/equipment';
import { Page } from '../../../models/paging/page';
import { Category } from '../../../models/category';
import { CompanyService } from '../../../services/company.service';
import { AuthService } from '../../../services/auth.service';
import { CategoryService } from '../../../services/category.service';
import { LocationService } from '../../../services/location.service';
import { EquipmentService } from '../../../services/equipment.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-asset-management',
  templateUrl: './asset-management.component.html',
  styleUrls: ['./asset-management.component.scss']
})


export class AssetManagementComponent implements OnInit {
  filter: any = {
    company_Id: 0,
    location_Id: 0,
    category_Id: 0,
    serial_Num: '',
    asset_Num: '',
    contract_No: ''
  };
  loading: boolean = false;
  default_filters = JSON.parse(JSON.stringify(this.filter));

  pageno: number;
  locationList: Location[];

  companies: Company[];
  locations: Location[];

  categories: Category[];

  page = new Page();
  rows = Array<Equipment>();
  equipAccess = false;
  user;
  constructor(public companyService: CompanyService, public locationService: LocationService, public categoryService: CategoryService,
    public equipmentService: EquipmentService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    if (this.authService.currentUser.value.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['reports/rote']);
    }
    this.page.pageNumber = 0;
    this.page.size = 9999999;


    companyService.getAll().then((data) => {
      this.companies = data;
    });




    categoryService.getAll().then((data) => {
      this.categories = data;
    });

    // Check if any filters are present
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null)
      this.filter = filters;

   /* this.loadTable(this.page);*/

  }

  ngOnInit(): void {
   
  }

  onCompanyChange(value) {
    this.filter.locationId = 0;

    if (value == undefined)
      this.filter.companyId = undefined;
    else
      this.filter.companyId = value.id;

  }

  onLocationChange(value) {
    if (value == undefined)
      this.filter.locationId = undefined;
   else
    this.filter.locationId = value.id;

  }

  onCategoryChange(value) {
    if (value == undefined)
      this.filter.categoryId = undefined;
   else
      this.filter.categoryId = value.id;
  }
  edit(row) {
    //console.log(row);
    this.router.navigate(['admin/assets/manage'], { queryParams: { id: row.core_Id } });
  }
  add() {
    this.router.navigate(['admin/assets/manage']);
  }

  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable(this.page);
  }

  rebind() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.loading = true;
    this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.equipmentService.getResults(this.page, this.filter.companyId, this.filter.locationId, this.filter.categoryId, this.filter.serial_Num, this.filter.asset_Num, this.filter.contract_No).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      //console.log(this.rows);
      this.loading = false;
    });
  }

  generateExcel() {

    this.equipmentService.getExcel(this.page,
      this.filter.insurer_Id, this.filter.broker_Id,
      this.filter.company_Id, this.filter.location_Id,
      this.filter.category_Id, this.filter.serial_Num, this.filter.asset_Num).then((data) => {
      importedSaveAs(data, 'Equipment.xlsx');
    });
  }

}
